module.exports = __webpack_public_path__ + "static/media/icon-password-red.37da0567.svg";